import { useQuery } from "@apollo/client"
import { client } from "../../graphql/contentful/client"
import { CONTENTFUL_STORE_HOME_PAGE_ID as id } from "../../utils/contentful-constants"
import { gql } from "@apollo/client"

export const QUERY_STORE_HOME_PAGE = gql`
  query getStoreHomePage($id: String!) {
    storeHomepage(id: $id) {
      coverImage {
        title
        url
      }
      heading
      subtitle
      coverImageTop
      coverImageLeft
    }
  }
`

export const useStoreHomePage = () => {
  const { data, error, loading, refetch } = useQuery(QUERY_STORE_HOME_PAGE, {
    client: client,
    variables: { id },
  })
  return {
    storeHomePage: data?.storeHomepage,
    shpError: error,
    shpLoading: loading,
    refetch,
  }
}
